import styled from 'styled-components';

export const StyledCurrentPageSelect = styled.select`
  appearance: none;
  box-shadow: inset 0px 2px 3px rgba(0, 0, 0, 0.15);
  border-radius: 3px;
  background: #ffffff;
  border: 1px solid #c8c8c8;
  font-family: inherit;
  font-size: 1rem;
  height: 24px;
  width: 44px;
  margin-left: 20px;
  text-align: center;
  text-align-last: center;
`;
